class AnnouncementTape extends HTMLElement {
    tape = null;
    tapeCarousel = null;
    tapeNav = null;
    tapePrevButton = null;
    tapeNextButton = null;
    autoScrollInterval = null;
    autoScrollDelay = 4000;

    constructor() {
        super();
    }

    connectedCallback() {
        this.tape = this.querySelector('[data-id="tape"]');
        this.tapeCarousel = this.querySelector('[data-id="tape-carousel"]');
        this.tapeNav = this.querySelector('[data-id="tape-nav"]');
        this.tapePrevButton = this.tapeNav?.querySelector('[data-id="button-prev"]');
        this.tapeNextButton = this.tapeNav?.querySelector('[data-id="button-next"]');

        this.tapePrevButton.addEventListener('click', (e) => {
            this.scroll(-1);
            this.startAutoScroll();
        });

        this.tapeNextButton.addEventListener('click', (e) => {
            this.scroll(1);
            this.startAutoScroll();
        });

        this.tapeCarousel.addEventListener('mouseenter', this.stopAutoScroll);
        this.tapeCarousel.addEventListener('mouseleave', this.startAutoScroll);
        this.tapeCarousel.addEventListener('scroll', this.updateButtonVisibility);

        this.updateButtonVisibility();
        this.startAutoScroll();
    }

    startAutoScroll() {
        this.stopAutoScroll();
        this.autoScrollInterval = setInterval(() => {
            if (this.isAtEnd()) {
                this.tapeCarousel.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                this.scroll(1);
            }
        }, this.autoScrollDelay);
    };

    stopAutoScroll () {
        clearInterval(this.autoScrollInterval);
    };

    scroll (direction) {
        this.tapeCarousel.scrollBy({
            left: direction * (this.tapeCarousel.offsetWidth / 2),
            behavior: 'smooth'
        });
    };

    isAtEnd () {
        return this.tapeCarousel.scrollLeft + this.tapeCarousel.offsetWidth >= this.tapeCarousel.scrollWidth;
    };

    updateButtonVisibility = () => {
        this.tapePrevButton.classList.toggle('tape__nav-button--hidden', this.tapeCarousel.scrollLeft <= 0);
        this.tapeNextButton.classList.toggle('tape__nav-button--hidden', this.isAtEnd());
    };

    disconnectedCallback() {
        this.tapeCarousel.removeEventListener('mouseenter', this.stopAutoScroll);
        this.tapeCarousel.removeEventListener('mouseleave', this.startAutoScroll);
        this.tapeCarousel.removeEventListener('scroll', this.updateButtonVisibility);
    }
}

customElements.define("announcement-tape", AnnouncementTape);
